export const BOOKMARK_TITLE = "Daily Check-in - Reflection Journal";

export const ANALYSIS_DAYS_RANGE = 28;
export const ANALYSIS_MIN_CHECKINS = 5;
export const ANALYSIS_CHECK_INTERVAL = 2000;
export const ANALYSIS_GENERATION_DELAY = 2 * 1000;

export const FEELING_VALUES = {
	MUCH_BETTER: 3,
	SLIGHTLY_BETTER: 1,
	SLIGHTLY_WORSE: -1,
	MUCH_WORSE: -3,
} as const;

export const IMPACT_LEVELS = {
	NONE: 1,
	SLIGHT: 2,
	MEDIUM: 3,
	HIGH: 4,
	CRITICAL: 5,
} as const;

export const SIMILAR_REFLECTION_THRESHOLD = 0.3;
export const DESCRIPTION_PREVIEW_LENGTH = 200;
